<template>
  <card-container
    :id="pageId"
    :is-loading="isLoading"
    :disabled="isLoading"
    loading-message="Sending Pharmacy Driver Has Arrived Call..."
    @submit="sendArrivingCall"
    @reset="resetForm"
  >
    <template #title>
      Send Pharmacy Driver Has Arrived Call
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label">Caller ID*</label>
        <div class="col-sm-7">
          <sanitized-input
            :id="`callerId-${pageId}`"
            v-model="requestBody.callerId"
            placeholder="Please input caller id"
            required
          />
        </div>
      </div>

      <div class="row">
        <label class="col-sm-3 control-label pt-10"> Phone Number </label>
        <phone-number-input
          id="customer-phone"
          v-model="requestBody.phoneNumber"
          class="col-sm-7"
          :page-id="pageId"
          :required="false"
        >
          <template #help-block>
            If no phone number is inputed, the driver arriving call will be sent to the preferred contact number of the customer. If you
            would like to have the driver arriving call sent to a different phone number, please enter it here
          </template>
        </phone-number-input>
      </div>
    </template>

    <template #submit-button>
      Send Arriving Call
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { rideService } from '@/services/ride';

const pageId = 'pharmacy-driver-arriving-call';

export default {
  name: 'PharmacyDriverArrivingCall',

  setup: () => {
    const { customerInfo } = useCustomer();
    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const requestBody = ref({
      callerId: '',
      phoneNumber: '',
    });

    const isLoading = ref(false);

    const sendArrivingCall = async () => {
      requestBody.value.phoneNumber = util.getValidPhoneNumber(requestBody.value.phoneNumber);

      isLoading.value = true;
      try {
        await rideService.sendPharmacyDriverArrivedCall(requestBody.value);
        showSuccessPopupDialog({
          text: 'The pharmacy driver arrived call has been sent successfully.',
        });
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      requestBody.value = {
        callerId: customerInfo.value?.id ?? '',
        phoneNumber: '',
      };
    };

    watch(customerInfo, resetForm, {
      immediate: true,
    });

    return {
      pageId,
      requestBody,
      isLoading,

      sendArrivingCall,
      resetForm,
    };
  },
};
</script>
